import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13","key":"svg-0"}],["path",{"d":"M17 16l4 -4l-4 -4","key":"svg-1"}]]

/**
 * IconArrowLoopRight2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctbG9vcC1yaWdodC0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMXYtNm0wIC02di0xYTQgNCAwIDEgMCAtNCA0aDEzIiAvPgogIDxwYXRoIGQ9Ik0xNyAxNmw0IC00bC00IC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/arrow-loop-right-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowLoopRight2 = createReactComponent('outline', 'arrow-loop-right-2', 'ArrowLoopRight2', __iconNode);

export default IconArrowLoopRight2;